module.exports = __webpack_public_path__ + "static/media/telegramDark.7974f00f.svg";